import axios from 'axios'
import { API_KEY, API_URL } from '../keys'

export const fetchOrdersCountByStatus = async (token: string) => {
	const response = await axios.get(`${API_URL}/stadicts/order/status/count`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const getLatestCustomers = async (token: string) => {
	const response = await axios.get(`${API_URL}/stadicts/customers/last`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}

export const getLatestContacts = async (token: string) => {
	const response = await axios.get(`${API_URL}/stadicts/contacts/last`, {
		headers: {
			Authorization: `Bearer ${token}`,
			'sce-api-users-key-validation': API_KEY,
		},
		validateStatus: (status) => status < 500,
	})
	return response
}
